// extracted by css-extract-rspack-plugin
export default {"overview":"pD3HSZd69Yom5XHZ","title":"fnQcKZ5_k_MMazAY","main":"vplmnjZlsUMr_v2X","footer":"DppI7jQHIrwYT6Rp"};